export default __webpack_public_path__ + "static/media/safari.a243750e.svg";